"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconYoutube = function IconYoutube(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M20.931 6.029c.311.31.535.697.649 1.121.29 1.6.43 3.224.42 4.85a26.3 26.3 0 0 1-.42 4.85 2.51 2.51 0 0 1-1.77 1.77c-1.56.43-7.81.43-7.81.43s-6.25 0-7.81-.43a2.51 2.51 0 0 1-1.77-1.77A26.3 26.3 0 0 1 2 12c-.01-1.626.13-3.25.42-4.85a2.51 2.51 0 0 1 1.77-1.72C5.75 5 12 5 12 5s6.25 0 7.81.38c.424.114.81.338 1.121.649M15.18 12l-5.22 2.97V9.03z",
    clipRule: "evenodd"
  })));
};

export { IconYoutube, IconYoutube as default };
